export const defaultModelOptions = {
  debounce: {
    default: 500,
    blur: 0
  }
}

export function run($rootScope) {
  $rootScope.defaultModelOptions = defaultModelOptions
}
run.$inject = ['$rootScope']